import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  // Theme state
  theme: 'dark' | 'light' | 'system';
  
  // Modal states
  isCreatorUpgradeModalOpen: boolean;
  isCreatePostModalOpen: boolean;
  
  // Theme actions
  setTheme: (theme: 'dark' | 'light' | 'system') => void;
  
  // Modal actions
  openCreatorUpgradeModal: () => void;
  closeCreatorUpgradeModal: () => void;
  openCreatePostModal: () => void;
  closeCreatePostModal: () => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      // Theme state (default to dark)
      theme: 'dark',
      
      // Modal states
      isCreatorUpgradeModalOpen: false,
      isCreatePostModalOpen: false,
      
      // Theme actions
      setTheme: (theme) => set({ theme }),
      
      // Modal actions
      openCreatorUpgradeModal: () => set({ isCreatorUpgradeModalOpen: true }),
      closeCreatorUpgradeModal: () => set({ isCreatorUpgradeModalOpen: false }),
      openCreatePostModal: () => set({ isCreatePostModalOpen: true }),
      closeCreatePostModal: () => set({ isCreatePostModalOpen: false }),
    }),
    {
      name: 'alphatank-ui-storage',
      partialize: (state) => ({ theme: state.theme }),
    }
  )
); 